import { render, staticRenderFns } from "./general-perm-error.vue?vue&type=template&id=16602176"
import script from "./general-perm-error.vue?vue&type=script&lang=js"
export * from "./general-perm-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports